import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import "./ScheduleRule.scss";
import { useScheduleRuleData } from "./useScheduleRuleData";
import { renderTime } from "./renderTime";

export const ScheduleRule = ({
  timeStart,
  timeEnd,
  selectedDays,
  useShortNotations,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { start, end, days, duration } = useScheduleRuleData(
    timeStart,
    timeEnd,
    selectedDays,
    useShortNotations
  );
  const showDaysError = _.isEmpty(days);

  return (
    <div
      className={"rule__preview"}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={"rule__preview__time"}>
        <span className={"rule__preview__time--bold"}>
          <span>{renderTime(start)}</span>
          {" – "}
          <span>{renderTime(end)}</span>
        </span>
        <span>{duration}</span>
      </div>
      <div className={"rule__preview__days"}>
        {showDaysError ? (
          <FormattedMessage id={"days_error"} />
        ) : (
          days.join(", ")
        )}
      </div>
    </div>
  );
};
